import "pickadate/lib/picker.js";
import "pickadate/lib/picker.date.js";
import "pickadate/lib/picker.time.js";
import "pickadate/lib/translations/fr_FR.js";

import formSelect from '../modules/form';
import 'select2';

import * as FormValidation from 'formvalidation';
import Bootstrap from 'formvalidation/dist/es6/plugins/Bootstrap';

$(document).ready(function () {
    formSelect();

    // STEP DONE - suppression du chiffre
    $('.done .steps-list__step-marker').html("");

    //Step 1 : Vehicle
    //Immat block
    // $('#no-immat-button, #immat-button').click(function() {
    //     $('#immat-block').toggle();
    //     $('#no-immat-block').toggle();
    //
    //     $('#vehicle_registrationNumber').val('');
    //     $('#vehicle_maker').val('');
    //     $('#vehicle_model').val('');
    // });

    // if($('[data-related-choice-default-value]').data('related-choice-default-value') != '') {
    //     $('#immat-block').toggle();
    // } else {
    //     $('#no-immat-block').toggle();
    // }

    /* FORM VALIDATION */
    const form = document.getElementById('form-rdv');
    if (form !== null) {
        FormValidation.formValidation(form, {
            fields: {
                'vehicle[registrationNumber]': {
                    validators: {
                        callback: {
                            message: "L'immatriculation est obligatoire",
                            callback: function (input) {
                                if (input.value === '') {
                                    return false;
                                }

                                if (input.value.match(/^(?!ss)[a-hj-np-tv-z]{2}[ -]{0,1}?[0-9]{3}[ -]{0,1}?(?!ss)[a-hj-np-tv-z]{2}$/i) === null && input.value.match(/^[0-9]{1,4}[ -]{0,1}[A-HJ-NP-TV-Z]{2,3}[ -]{0,1}([0-9]{1,3}|2[AB])$/i) === null) {
                                    return {
                                        valid: false,
                                        message: 'Le format est invalide.'
                                    };
                                }

                                return true;
                            }
                        }
                    }
                },
                'vehicle[maker]': {
                    validators: {
                        callback: {
                            message: "La marque du véhicule est obligatoire",
                            callback: function (input) {
                                if (input.value === '') {
                                    return false;
                                }

                                return true;
                            }
                        }
                    }
                },
                'vehicle[model]': {
                    validators: {
                        callback: {
                            message: "Le modèle du véhicule est obligatoire",
                            callback: function (input) {
                                if (input.value === '') {
                                    return false;
                                }

                                return true;
                            }
                        }
                    }
                },
                'vehicle[mileage]': {
                    validators: {
                        notEmpty: {
                            message: "Le kilométrage est obligatoire."
                        }
                    }
                },

                'lead[lead][lastname]': {
                    validators: {
                        notEmpty: {
                            message: "Le nom est obligatoire."
                        }
                    }
                },
                'lead[lead][firstname]': {
                    validators: {
                        notEmpty: {
                            message: "Le prénom est obligatoire."
                        }
                    }
                },
                'lead[lead][phone]': {
                    validators: {
                        notEmpty: {
                            message: "Le téléphone est obligatoire."
                        },
                        stringLength: {
                            max: 10,
                            min: 10,
                            message: 'Le téléphone doit contenir 10 caractères.'
                        },
                    }
                },
                'lead[lead][gender]': {
                    validators: {
                        notEmpty: {
                            message: "La civilité est obligatoire."
                        }
                    }
                },
                'lead[lead][email]': {
                    validators: {
                        notEmpty: {
                            message: "L'email est obligatoire."
                        },
                        emailAddress: {
                            message: "N'est pas une adresse mail valide."
                        }
                    }
                },
                'lead[lead][zipcode]': {
                    validators: {
                        notEmpty: {
                            message: "Le code postal est obligatoire."
                        }
                    }
                },
                'lead[lead][city]': {
                    validators: {
                        notEmpty: {
                            message: "La ville est obligatoire."
                        }
                    }
                },
                'date_and_time[desiredDate]': {
                    validators: {
                        notEmpty: {
                            message: "La date de rendez-vous est obligatoire."
                        }
                    }
                },
                'date_and_time[desiredTime]': {
                    validators: {
                        notEmpty: {
                            message: "L'heure de rendez-vous est obligatoire."
                        }
                    }
                },
                'date_and_time[mobilitySolution]': {
                    validators: {
                        notEmpty: {
                            message: "Ce champ est obligatoire"
                        }
                    }
                },
                'rdv_type[rdvTypeMessage]': {
                    validators: {
                        callback: {
                            message: "Votre message ne doit pas dépasser les 1500 caractères",
                            callback: function (input){
                                if(input.value.length > 1500) {
                                    return {
                                        valid: false,
                                        message: "Votre message ne doit pas dépasser les 1500 caractères"
                                    };
                                }
                            }
                        }
                    }
                },
               'vehicle[message]':{
                   validators: {
                       callback: {
                           message: "Votre message ne doit pas dépasser les 1500 caractères",
                           callback: function (input){
                               if(input.value.length > 1500) {
                                   return {
                                       valid: false,
                                       message: "Votre message ne doit pas dépasser les 1500 caractères"
                                   };
                               }
                           }
                       }
                   }
               }
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new Bootstrap(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                /*icon: new FormValidation.plugins.Icon({
                    valid: 'fa fa-check',
                    invalid: 'fa fa-times',
                    validating: 'fa fa-refresh'
                }),*/ //Avec Bootstrap 4, ne pas oublier d'importer une fontIcons
                // declarative
                declarative: new FormValidation.plugins.Declarative({html5Input: true})
            }
        });
    }

    var now = new Date();
    var day = now.getDay();

    if ($('#date_and_time_desiredDate').length > 0) {
        $('#date_and_time_desiredDate').prop('disabled', true);
        $('.rdv-hour').prop('disabled', true);

        //Ajax
        var externalSiteId = $('#date_and_time_externalSiteId').val();

        $.ajax({
            method: "POST",
            url: '/ajax/rdv/charge',
            data: { externalSiteId: externalSiteId }
        }).done(function (response) {
            if (response.success === true) {
                initPickadate(response.content);

                $('#date_and_time_desiredDate').prop('disabled', false);
            } else {
                $('#rdv-date .fv-plugins-message-container').html(response.content);
            }
        });
    }

    function initPickadate(content)  {
        var disabledDates = [];
        var firstDate     = null;
        var lastDate      = null;

        $.each(content, function(index, value) {
            var date = new Date(value.date);

            if (value.disponible === false) {
                disabledDates.push(date);
            } else {
                if (firstDate === null) {
                    firstDate = date;
                }
            }

            lastDate = date;
        });

        if (firstDate !== null) {
            $('#date_and_time_desiredDate').pickadate({
                selectYears: false,
                min: firstDate,
                max: lastDate,
                disable: disabledDates,
                onClose: function() {
                    $('form[name=date_and_time]').formValidation('revalidateField', 'date_and_time[desiredDate]');
                },
                onSet: function(context) {
                    var desiredDate = this.get('value');
                    $('#date-reception').html('Nous recherchons les horaires disponibles.')
                    $('#rdv-hour input[type=hidden]').val('');

                    getReception(externalSiteId, desiredDate);
                },
                firstDay: 1,
                format: 'dd/mm/yyyy',
                formatSubmit: 'dd/mm/yyyy'
            });

            // Si une date a déjà été choisie, on lance l'appel AJAX affichant les heures disponibles
            if ($('#date_and_time_desiredDate').val() !== '') {
                getReception($('#date_and_time_externalSiteId').val(), $('#date_and_time_desiredDate').val(), true);
            }
        } else {
            $('#rdv-date').html("Nous n'avons pour le moment aucun créneau de libre.")
        }
    }

    function getReception(externalSiteId, desiredDate, firstDisplay = false) {
        $.ajax({
            method: "POST",
            url: '/ajax/rdv/reception',
            data: { externalSiteId: externalSiteId, desiredDate: desiredDate }
        }).done(function (response) {
            displayScheduleHours(response.content);

            if (firstDisplay === true) {
                selectScheduleHourOnLoad();
            }
        });
    }

    function selectScheduleHourOnLoad() {
        // Si au chargement de la page, une heure a déjà été choisie, on la préselectionne si possible
        if ($('#date_and_time_desiredTime').val() !== '') {
            let choseTime        = $('#date_and_time_desiredTime').val();
            let choseTimeElement = $("#date-reception").find('[data-hour="' + choseTime + '"]');

            // Si le block d'heure existe ET qu'il n'est pas inactif
            if (choseTimeElement.length === 1 && choseTimeElement.hasClass('inactive') === false) {
                choseTimeElement.addClass('active');
            } else {
                choseTimeElement.val('');
            }
        }
    }

    function displayScheduleHours(content) {
        $('#date-reception').html(content);

        $('#rdv-hour .rdv-hour').on('click', function(e) {
            e.preventDefault();

            if ($(this).hasClass('active')) {
                $('#rdv-hour .rdv-hour').removeClass('active');
                var HourData = '';
            } else {
                $('#rdv-hour .rdv-hour').removeClass('active');
                $(this).addClass('active');
                var HourData = $(this).data('hour');
            }

            $('#date_and_time_desiredTime').val(HourData);
        });
    }

    /*$('.firstLetterCapitalize .select2').on('click', function(e) {
        $('.select2-container').addClass('capitalize');
    });*/
});



// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/rdv/rdv.js